// Reusable functions to bind events
function bindCartAddons() {
  const addons = document.querySelectorAll(".cart-addon");

  addons.forEach(async (addon) => {
    const checkbox = addon.querySelector(".addon-checkbox");
    const variantId = checkbox.dataset.variantId;
    const toggle = addon.querySelector(".addon-toggle");
    const desc = addon.querySelector(".addon-description");

    // Pre-check if this variant is already in the cart
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    const item = cart.items.find((i) => i.variant_id == variantId);
    if (item) checkbox.checked = true;

    toggle?.addEventListener("click", () => {
      desc.classList.toggle("open");
      toggle.querySelector(".addon-toggle-icon").textContent =
        desc.classList.contains("open") ? "−" : "+";
    });

    checkbox?.addEventListener("change", async () => {
      if (checkbox.checked) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
      } else {
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();
        const item = cart.items.find((i) => i.variant_id == variantId);
        if (item) {
          const removed = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
          if (removed.ok) {
            await refreshCartDrawer(); // Refresh only after successful remove
          }
        }
      }
      await refreshCartDrawer();
    });
  });
}

function bindQuantityControls() {
  document
    .querySelectorAll(".cart-drawer-item__quantity-container")
    .forEach((container) => {
      const input = container.querySelector(".quantity-input");
      const increaseBtn = container.querySelector('[data-action="increase"]');
      const decreaseBtn = container.querySelector('[data-action="decrease"]');
      const removeBtn = container.querySelector(".remove-btn");

      const spinner = document.createElement("div");
      spinner.className = "spinner";
      spinner.innerHTML = `
      <svg class="spinner-icon" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"/>
      </svg>
    `;

      const setLoading = (state) => {
        increaseBtn.disabled = state;
        decreaseBtn.disabled = state;
      };

      increaseBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        const newQty = parseInt(input.value) + 1;

        setLoading(true);
        if (await updateCart(key, newQty))
          await refreshCartDrawer((scrollToTop = true));
      });

      decreaseBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        let currentQty = parseInt(input.value);
        const maxQty = parseInt(input.max);
        console.log(currentQty, maxQty);
        if (currentQty > maxQty) currentQty = maxQty + 1;
        if (currentQty <= 1) return;
        setLoading(true);
        if (await updateCart(key, currentQty - 1))
          await refreshCartDrawer((scrollToTop = true));
      });

      removeBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        removeBtn.disabled = true;
        removeBtn.innerHTML = `<span class="add-to-cart-spinner"></span>`;
        removeBtn.style.borderBottom = "none";
        if (await updateCart(key, 0)) await refreshCartDrawer();
      });
    });
}

function bindAddToCartButtons() {
  document
    .querySelectorAll(".cart-drawer-item__add-to-cart-btn")
    .forEach((btn) => {
      const variantId = btn.dataset.variantId;

      // Avoid duplicate listeners
      btn.removeEventListener("click", btn._boundHandler);

      // Define and store the handler
      const handler = async () => {
        if (!variantId) return;

        // Store original content to restore later
        const originalHTML = btn.innerHTML;

        // Add loading state
        btn.disabled = true;
        btn.innerHTML = `<span class="add-to-cart-spinner"></span>`;

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });

          console.log(await res.json());
          await refreshCartDrawer();
        } catch (err) {
          console.log(err);
        } finally {
          // Restore original button
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        }
      };

      btn._boundHandler = handler;
      btn.addEventListener("click", handler);
    });
}

const cartIcon = document.querySelector(".js-drawer-open-cart");
if (cartIcon) {
  cartIcon.addEventListener("click", function (e) {
    e.preventDefault();
    openCartDrawer();
  });
}

function openCartDrawer(newCart = true) {
  if (newCart) {
    refreshCartDrawer();
  }
  setTimeout(() => {}, 300); // Allow DOM to update before showing drawer
  const cartDrawer = document.getElementById("cartDrawer");
  const overlay = document.getElementById("cartDrawerOverlay");
  cartDrawer.classList.add("open");
  overlay.classList.add("show");
  document.body.style.overflow = "hidden";

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCartDrawer();
  });

  overlay.addEventListener("click", closeCartDrawer);
}

function closeCartDrawer() {
  const cartDrawer = document.getElementById("cartDrawer");
  const overlay = document.getElementById("cartDrawerOverlay");
  document.body.style.overflow = "";
  cartDrawer.classList.remove("open");
  overlay.classList.remove("show");
}

function updateShippingProgressBar() {
  const shippingProgressContainer = document.getElementById(
    "cart-shipping-progress"
  );
  if (!shippingProgressContainer) return;

  const subtotal = parseFloat(shippingProgressContainer.dataset.cartSubtotal);
  const threshold = parseFloat(
    shippingProgressContainer.dataset.freeShippingThreshold
  );
  const preMessage = shippingProgressContainer.dataset.cartPreMessage;
  const postMessage = shippingProgressContainer.dataset.cartPostMessage;
  const remaining = Math.max(0, threshold - subtotal).toFixed(2);
  const percentage = Math.min(100, (subtotal / threshold) * 100).toFixed(1);

  const shippingMessage = document.getElementById("shippingRemaining");
  const pdpShippingMessage = document.getElementById("pdp-shipping-message");
  const progressBar = document.getElementById("progressBarFill");

  if (shippingMessage) {
    shippingMessage.textContent =
      remaining > 0
        ? preMessage?.replace("[remainingForGoalFormatted]", `$${remaining}`)
        : postMessage;
  }
  if (pdpShippingMessage) {
    pdpShippingMessage.textContent =
      remaining > 0 ? `Add $${remaining} more for free shipping!` : postMessage;
  }
  if (progressBar) progressBar.style.width = `${percentage}%`;
}

const cartDrawer = document.querySelector("#cartDrawerContainer");
const getLineItemKey = (el) =>
  el.closest("[data-line-item-key]")?.dataset.lineItemKey;
const updateCart = async (lineKey, quantity) => {
  try {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity }),
    });
    return res.ok;
  } catch (error) {
    console.log(error);
  }
};

const restoreCartScroll = (cartScrollTop) => {
  const cartDrawer = document.getElementById("cartDrawer");
  if (cartDrawer) {
    cartDrawer.scrollTop = cartScrollTop;
  }
};

const refreshCartDrawer = async (scrollToTop) => {
  const cartScrollTop = document.getElementById("cartDrawer").scrollTop;
  const res = await fetch(
    window.location.pathname + "?sections=new-cart-drawer"
  );
  const data = await res.json();
  if (data["new-cart-drawer"] && cartDrawer) {
    cartDrawer.innerHTML = data["new-cart-drawer"];
    document.getElementById("cartDrawer")?.classList.add("open");
    document.getElementById("cartDrawerOverlay")?.classList.add("show");
    document.body.style.overflow = "hidden";
    bindCartAddons();
    bindQuantityControls();
    updateShippingProgressBar();
    bindAddToCartButtons();
    if (scrollToTop) {
      restoreCartScroll(cartScrollTop);
    }
    const cartCount = document.getElementById("cart-drawer-item-count")?.dataset
      ?.cartCount;
    const bubble = document.querySelector(".cart-link__bubble");
    if (bubble && cartCount) {
      bubble.innerText = cartCount;
      // bubble.classList.toggle("cart-link__bubble--visible", cartCount > 0);
    }
    if (Number(cartCount) <= 0) {
      const pdpShippingMessage = document.getElementById(
        "pdp-shipping-message"
      );
      if (pdpShippingMessage) {
        pdpShippingMessage.textContent = "";
      }
    }
  }
};

// Initial bindings
bindCartAddons();
bindQuantityControls();
updateShippingProgressBar();
bindAddToCartButtons();
